import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children, requiredRole }) => {
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("userRole");

    const loginType = requiredRole === "Employee"
        ? "employee"
        : requiredRole === "Contractor"
            ? "contractor"
            : requiredRole === "SuperAdmin"
                ? "superadmin"
                : requiredRole === "Reseller"
                    ? "reseller"
                    : "company";

    if (!token) {
        return <Navigate to={`/login/${loginType}`} replace />;
    }

    // Accountants and Location managers can access the Company dashboard.
    // Resellers may also enter the company dashboard after switch-company.
    const allowedRoles = requiredRole === "Company"
        ? ["Company", "Accountant", "Location", "Reseller"]
        : [requiredRole];

    if (requiredRole && !allowedRoles.includes(role)) {
        return <Navigate to={`/login/${loginType}`} replace />;
    }

    return children;
};

export default PrivateRoute;
